module.exports = __webpack_public_path__ + "img/containerRearRightOutline.2909a39e.svg";